import { render } from "./Pagination.vue?vue&type=template&id=16fa5983"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/page/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16fa5983"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16fa5983', __exports__)) {
    api.reload('16fa5983', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=16fa5983", () => {
    api.rerender('16fa5983', render)
  })

}


export default __exports__